export const INIT_LOGIN = 'INIT_LOGIN'
